import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Diagnostics from "./sections/Diagnostics";
import Authority from "./sections/Authority";
import TestingProcess from "./sections/TestingProcess";
import SpecializedInspection from "./sections/SpecializedInspection";
import Secure from "./sections/Secure";
import Testimonials from "./sections/Testimonials";
import Expertise from "./sections/Expertise";
import MoldReports from "./sections/MoldReports";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <Diagnostics />
      <Authority />
      <TestingProcess />
      <SpecializedInspection />
      <Secure />
      <Testimonials />
      <Expertise />
      <MoldReports />
      <Footer />
    </div>;
}